import React from 'react';
import { Link } from 'react-router-dom';
import {
  Collapse,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Row,
  Col,
} from 'reactstrap';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import classnames from 'classnames';

const MyNavbar = () => {
  const logoWhite = require('../assets/img/logo/white.png');
  const logoBlack = require('../assets/img/logo/black.png');
  const iconWhite = require('../assets/img/menu-white.png');
  const iconBlack = require('../assets/img/menu-black.png');
  const [collapsed, setCollapsed] = React.useState(false);
  const [bgColor, setBgColor] = React.useState('navbar-transparent');
  const [width, setWidth] = React.useState(
    document.documentElement.clientWidth <= 270 ? 100 : 200
  );
  const [logo, setLogo] = React.useState(logoWhite);
  const [icon, setIcon] = React.useState(iconWhite);

  React.useEffect(() => {
    if (!collapsed) {
      document.documentElement.classList.remove('nav-open');
    }
  });

  React.useEffect(() => {
    const onScroll = () => {
      if (
        document.documentElement.scrollTop > 99 ||
        document.body.scrollTop > 99
      ) {
        setLogo(logoBlack);
        setIcon(iconBlack);
        setBgColor('bg-white');
        setWidth(document.documentElement.clientWidth <= 270 ? 75 : 150);
      } else if (
        document.documentElement.scrollTop < 100 ||
        document.body.scrollTop < 100
      ) {
        setLogo(logoWhite);
        setIcon(iconWhite);
        setBgColor('navbar-transparent');
        setWidth(document.documentElement.clientWidth <= 270 ? 100 : 200);
      }
    };
    window.addEventListener('scroll', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, [iconBlack, iconWhite, logoBlack, logoWhite]);

  const toggleNavbar = () => {
    document.documentElement.classList.toggle('nav-open');
    setCollapsed(!collapsed);
  };

  // Hamburger Menu
  // Change expand prop on Navbar.js:59 and Comment lines on _navbar.scss:257 for responsive
  return (
    <>
      <Navbar
        className={`fixed-top navbar-fixed-top ${bgColor}`}
        expand={false}
        id="navbar"
      >
        <div>
          <NavbarBrand to="/" tag={Link} className="my-0 py-0">
            <LazyLoadImage
              alt="Kia's Logo"
              src={logo}
              width={width}
              className="my-0"
            />
          </NavbarBrand>
        </div>
        <div>
          <button
            aria-expanded={collapsed}
            className={classnames('navbar-toggler navbar-toggler', {
              toggled: collapsed,
            })}
            onClick={toggleNavbar}
          >
            <img alt="menu icon" src={icon} height="36px" width="36px" />
          </button>
        </div>
        {/* <NavbarToggler onClick={toggleNavbar} /> */}
        <Collapse className="justify-content-end" isOpen={collapsed} navbar>
          <Nav navbar expand={false} className="navbar-uppercase ml-auto">
            <NavItem>
              <div className="nav-link">
                <Row>
                  <Col sm="4">
                    <button
                      aria-expanded={collapsed}
                      className={classnames(
                        'navbar-toggler navbar-toggler my-1',
                        {
                          toggled: collapsed,
                        }
                      )}
                      onClick={toggleNavbar}
                    >
                      <img
                        alt="close icon"
                        src={require('../assets/img/close.png')}
                        height="36px"
                        width="36px"
                      />
                    </button>
                  </Col>
                </Row>
              </div>
            </NavItem>
            <NavItem>
              <NavLink to="/#firstSection" tag={Link}>
                Home
              </NavLink>
            </NavItem>
            {/* <NavItem>
              <NavLink to="/productos" tag={Link}>
                Productos Kia's
              </NavLink>
            </NavItem> */}
            <NavItem>
              <NavLink to="/#services" tag={Link}>
                servicios
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink to="/fabrica" tag={Link}>
                Fábrica
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink to="/catalogos" tag={Link}>
                Catálogos
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink to="/contacto" tag={Link}>
                Contacto
              </NavLink>
            </NavItem>
          </Nav>
        </Collapse>
      </Navbar>
    </>
  );
};

export default MyNavbar;
